// channel-socket.jsx
import React, { useEffect, useRef } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';

const ChannelSocket = ({ wsUrl, onMessage }) => {
  // Use the hook and destructure lastMessage
  const { lastMessage } = useWebSocket(`/${wsUrl}`) || {};
  
  // Store the last processed message so we don't re-send duplicates.
  const lastProcessedRef = useRef(null);

  useEffect(() => {
    if (lastMessage && onMessage) {
      const messageString = JSON.stringify(lastMessage);
      // Only call onMessage if the new message is different from what we processed last.
      if (messageString !== lastProcessedRef.current) {
        lastProcessedRef.current = messageString;
        //console.log('ChannelSocket: Calling onMessage with:', lastMessage, 'for wsUrl:', wsUrl);
        onMessage(lastMessage);
      }
    }
  }, [lastMessage, onMessage, wsUrl]);

  return null;
};

export default ChannelSocket;
